module.exports = __webpack_public_path__ + "static/media/photo127.68deba98.jpg";